import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ToastMsgComponent } from "./modules/shared/toast-msg/toast-msg.component";
import { LoaderComponent } from "./modules/shared/loader/loader.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastMsgComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone:true
})
export class AppComponent implements OnInit {
  title = 'globalCards';

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

 
    onActivate(event: any) {
    console.log('Activated Component:', event);
  }
}
